import React, { Component, Fragment } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { ReactComponent as Back } from 'Icons/back-bordered.svg';
import { ReactComponent as Forward } from 'Icons/forward-bordered.svg';
import { ReactComponent as Gear } from 'Icons/gear.svg';
import { ReactComponent as Filter } from 'Icons/filter.svg';
import { ReactComponent as Grid } from 'Icons/grid.svg';
import { ReactComponent as Listing } from 'Icons/listing.svg';
import { ReactComponent as DropdownIcon } from 'Icons/download-white.svg';
import { ReactComponent as UploadIcon } from 'Icons/upload-blue.svg';
import Dropdown from 'Components/Dropdown';

import Timer from '../../Timer';
import Activity from '../../Activity';
import { Status } from '../../Status';
import {
   SERVICE_TYPES,
   RFQ_TABLE_DATE_FORMAT,
   RFQ_TYPE_NAMES,
   SHIPPING_TYPE_NAMES,
   RIL,
   ADANI
} from 'Constants/commonConstants';
import { SERVICE_MODES } from 'Constants/commonConstants';
import Upload from 'Components/Upload';
import ResponsiveTable from 'Components/ResponsiveTable';


export default class AllRfqs extends Component {

   constructor(props) {
      super(props);
      this.pickupRfq = this.pickupRfq.bind(this);
   }

   pickupRfq(rfq) {
      localStorage.setItem('teg-component', true);
      location.href = "/rfq/details/" + rfq.id + "/" + rfq.type;
   }


   getHeaders(status, rfqs) {
      const isServiceEnable = (rfqs || []).some(rfq => rfq.type === 8);
      return <div className="flex flex-between mb-20 ">
         <div className="fBold fs-16 header-dark-color pl-15 wt-150">Company</div>
         {(!isServiceEnable && rfqs.length != 0) && <div className="fBold fs-16 header-dark-color pl-15 col-8">Service</div>}
         {
            (status === 5) ? <div className="fBold fs-16 header-dark-color col-8 pl-15">CP
                <span className="orange-color"> Sent</span> | <span className="success-color">Accept</span> | <span className="error-color">Reject</span></div>
               : (status === 2) ? <div className="fBold fs-16 header-dark-color pl-15 col-8 ">Bid Time</div>
                  : <div className="fBold fs-16 header-dark-color pl-15 col-8 ">Bid Time Left</div>
         }
         <div className="fBold fs-16 header-dark-color pl-15 col-8">Status</div>
         {(!isServiceEnable && rfqs.length != 0) && <div className="fBold fs-16 header-dark-color pl-15 col-8">Mode Type</div>}
         <div className="fBold fs-16 header-dark-color pl-15 col-8">Floated On</div>
         <div className="fBold fs-16 header-dark-color pl-15 wt-200">Tenure</div>
         {(status === 5) && <div className="fBold fs-16 header-dark-color col-6 pl-15">LOI <span className="orange-color">Received </span>| <span className="success-color">Accept </span>|<span className="error-color"> Reject</span> | <span className="caption-color">Ignored</span></div>}
      </div>
   }

   getServiceNameOfType = (type) => {
      return (SERVICE_TYPES.find((obj) => obj.value === type || {})).name;

   }

   getServiceTypeMode = (rfqDetails, type) => {
      let serviceModes = "";
      rfqDetails.serviceModes.map((serviceMode) => {
         serviceModes = serviceModes + " " + (SERVICE_MODES.find((obj) => obj.value === serviceMode) || {})[type === 5 ? 'name2': 'name'];
      });
      return serviceModes;
   }

   pickupDraft = (rfq) => {
      this.props.pickupDraft(rfq);
   }

	onChange = (file) => {
		this.props.uploadServiceCategory(file);
   }
   
   onChangeServiceAvailability= (data) => {
      this.props.onChangeServiceAvailability({
         ...data,
         service_availability: data.service_availability === "yes" ? "No" : "yes"
      });
   }
   

	getServiceCategoryBody(){
      const { serviceCategoryList } = this.props;
		return(
         <Fragment>
            <div className="flex flex-between mb-20">
               <div className="fBold fs-16 header-dark-color pl-15 wt-150">Zone</div>
               <div className="fBold fs-16 header-dark-color pl-15 col-8">State</div>
               <div className="fBold fs-16 header-dark-color pl-15 col-8">City</div>
               <div className="fBold fs-16 header-dark-color pl-15 col-8">Pin Code</div>
               <div className="fBold fs-16 header-dark-color pl-15 col-8">Service Availability</div>
            </div>
            {(serviceCategoryList || []).map((data, index) => {
               return(
                  <div className="flex flex-between flex-middle border-top-light pt-25 pb-25 bg-hover-light">
                     <div className="fs-14 table-text-color pl-15 wt-150">{data.zone}</div>
                     <div className="fs-14 table-text-color pl-15 col-8">{data.state}</div>
                     <div className="fs-14 table-text-color pl-15 col-8">{data.city}</div>
                     <div className="fs-14 table-text-color pl-15 col-8">{data.pincode}</div>
                     <div className="fs-14 table-text-color pl-15 col-8">{
                        <input 
                           type="checkbox"
                           checked={data.service_availability === "yes" ? true : false} 
                           onClick={() => this.onChangeServiceAvailability(data)} 
                        />
                     }</div>
                  </div>
               )
            })}
         </Fragment>
		)
	}

   getBody(status, rfq, index) {
      const { systemTime, searchString, history } = this.props;
      const  serviceTypeMode = rfq && this.getServiceTypeMode(rfq.rfqDetails, rfq.type) || '';
      const handleClick = () => {
         const params = new URLSearchParams();
         if (searchString) params.set('search', searchString);
         params.set('tab', status);
         history.push(`/rfq/details/${rfq.id}/${rfq.type}?${params.toString()}`);
      };
      return <div className={classNames("flex flex-between flex-middle border-top-light pt-25 pb-25 bg-hover-light curP", {})}
         key={index}
         onClick={handleClick}
      >
         <div className="pl-15 wt-150">
            <div className="fs-14 table-text-color fs-14 lh-15p fRegular">
               {rfq.companyName}
            </div>
            <div className="table-text-color fs-12 op-79 lh-15p">
               RFQ {rfq.rfqNumber}
            </div>
            <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
               {rfq.fuelName}
            </div>
            { this.conditionsToRenderPOSTBid(rfq) &&
                    <div className="mt-2 fSemibold orange-color1 fs-12 lh-15p">
                        POST BID
                    </div>}
            {this.conditionsToRenderPREBid(rfq) &&
                    <div className="mt-2 fSemibold orange-color1 fs-12 op-79 lh-15p">
                        PRE BID
                    </div>}
            {ADANI.includes(rfq.companyId) && rfq.disposal_contract_type && rfq.type === 9 &&
            <>
            <div style={{color:'blue'}}>{(rfq.disposal_contract_type===1)?'Depot Wise':((rfq.disposal_contract_type===2)?'Zone Wise':'')}</div>
            </>}
            
            {status === 5 && <div>
               <div className="fs-14 table-text-color fs-14 lh-15p fRegular ">
                  {rfq.bound_type === 1 ? (
                     <>
                       <span>In-Bound</span>
                     </>
                  ) : (
                     <>
                        <span>Out-Bound</span>
                     </>
                  )}
               </div>
               {(rfq.rfqDetails.contractTenureTo && rfq.rfqDetails.contractTenureTo > new Date()) ? <span className='fs-14 fBold success-color'>Active</span> : <span className='fs-14 fBold error-color'> Expired </span>}
            </div>}  
         </div>
         {rfq.type !== 8 && <div className="col-8 pl-15">
            <div className="table-text-color  fs-14 lh-15p">
               {rfq.serviceTypeName}{serviceTypeMode && `, ${serviceTypeMode}` || ''}
            </div>
            {rfq.type !== 15 && (<div className="table-text-color fs-12 op-79 lh-15p">
               {rfq.businessVolume}
            </div>)}
         </div>}
         {
            (status === 5) ? <div className="fs-16 header-dark-color col-8 pl-15">
               <span className="orange-color">{rfq.noOfCounterpriceSent || 0}</span>
               <span className="fBold fs-18"> | </span>
               <span className="success-color">{rfq.noOfCounterpriceAccepted || 0}</span>
               <span className="fBold fs-18"> | </span>
               <span className="error-color">{rfq.noOfCounterpriceRejected || 0}</span>
            </div> :
               (status === 2) ? <div className="col-8 pl-15">
                  <div className="fs-12 table-text-color op-79 lh-15p pb-5">
                     {moment(rfq.biddingDetails.from).format('Do MMM, YYYY h:mm:ss a')}
                  </div>
                  <span className="fBold fs-14"> to </span>
                  <div className="fs-12 table-text-color op-79 lh-15p pb-5">
                     {moment(rfq.biddingDetails.to).format('Do MMM, YYYY h:mm:ss a')}
                     <Timer from={rfq.rfqDetails.biddingStart} to={rfq.rfqDetails.biddingEnd} currentTime={systemTime} />
                  </div>
               </div>
                  :
                  <div className="fs-14 table-text-color col-8 pl-15">
                     <Timer from={rfq.rfqDetails.biddingStart} to={rfq.rfqDetails.biddingEnd} currentTime={systemTime} />
                  </div>
         }
         <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p"><Status isNew={rfq.isNew} status={rfq.status} /></div>
         {RFQ_TYPE_NAMES[rfq.type]} {rfq && (rfq.type===5) &&<span>({SHIPPING_TYPE_NAMES[rfq.shippingType]})</span>}
         <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">{moment(rfq.created).format(RFQ_TABLE_DATE_FORMAT)}</div>
         <div className="fs-14 table-text-color wt-200 pl-15 fs-14 lh-15p">
            <div>{moment(rfq.rfqDetails.contractTenureFrom).format(RFQ_TABLE_DATE_FORMAT)}
            <span className="fBold"> to </span>
            {moment(rfq.rfqDetails.contractTenureTo).format(RFQ_TABLE_DATE_FORMAT)}</div>
            {rfq.event_contract &&
            <>
               {!rfq.event_rfq_wishlist && (status === 2) && <div className='curP theme-color mt-5 fs-14 fBold tCenter' onClick={(e) => {
                  e.preventDefault();
                  this.props.onWishList(rfq)
               }}>Wishlist RFQ</div>}
               {rfq.event_rfq_wishlist && (rfq.event_rfq_wishlist || {}).wishlisted && !(rfq.event_rfq_wishlist || {}).email_sms_dispatch && 
                   <div className='curP theme-color mt-5 fs-14 fBold tCenter error-color' >Email and SMS are not sent</div>}
               {rfq.event_rfq_wishlist && (rfq.event_rfq_wishlist || {}).wishlisted && (rfq.event_rfq_wishlist || {}).email_sms_dispatch && 
                   <div className='curP theme-color mt-5 fs-14 fBold tCenter green-color' >Email and SMS are sent</div>}
            </>}
         </div>
         {(status === 5) && <div className="fs-14 table-text-color col-6 pl-15"><span className="orange-color">{rfq.noOfLoiReceived}</span><span className="fBold fs-18"> | </span><span className="success-color">{rfq.noOfLoiAccepted}</span> <span className="fBold fs-18"> | </span> <span className="error-color">{rfq.noOfLoiRejected}</span> <span className="fBold fs-18"> | </span> <span color="caption-color">{rfq.pending}</span>
         </div>}
      </div>
		
   }
   conditionsToRenderPOSTBid =(rfq)=>{
      const C1 = RIL.includes(rfq.companyId);
      const C2 = rfq.bidding_type === 1;
      if(C1 && C2){
          return true;
      }
      return false;   
   }

   conditionsToRenderPREBid =(rfq)=>{
      const C1 = RIL.includes(rfq.companyId);
      const C2 = rfq.bidding_type === 2;
      if(C1 && C2){
          return true;
      }
      return false;    
   }


   render() {
      const { rfqs, status, goToNextPage, goToPrevPage, gettingRfqs, limit, offset, rfqTypesList, onRFQTypeSelect, rfqType } = this.props;
      (rfqTypesList || []).forEach(list => {
         list.name = (list.name || '').replace('AWL ', '');
      });

      return (
         <div className="box-shadow br-5 pl-15 pr-15 pt-15 pb-15 mt-20 ml-40 ">
            <div className="flex flex-middle flex-between mb-30">
               <div className="flex-1">
                  <div className="flex flex-right">
                     {/* <button className="bg-white br-20 border-theme fBold fs-14 theme-color pl-20 pt-10 pb-10 pr-20 mr-10">
                                <UploadIcon />
                                <span className="pl-10">Upload RFQ Data</span>
                            </button>
                            <button className=" fBold br-20 fs-14 fBold fs-14  white-color bg-theme pl-20 pt-10 pb-10 pr-20 mr-10">
                                <DropdownIcon /> 
                                <span className="pl-10">Download RFQ</span>
                            </button> */}
                     {status === 88 &&<Fragment>
                        <div className="pt-5">
                           <button className="ht-25 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.props.downloadServiceCategory}>Download</button>
                        </div>
                        <div className="pt-5">
                           <Upload onChange={this.onChange}>
                              <button className="ht-25 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" >Upload</button>
                           </Upload>
                        </div>
                     </Fragment>}
                     <div className="pt-5 flex flex-middle">
                        <Dropdown 
                           className="wt-200 mr-20"
                           label="Select RFQ Type"
                           items={rfqTypesList}
                           displayKey="name"
                           onSelect = {onRFQTypeSelect}
                           selectedItem = {rfqType && (rfqTypesList || []).find(list =>list.id === rfqType) || null}
                           canClear={true}
                     />
                        {
									offset < limit && status !== 88 && <Back className="mr-10 mt-5" />
                        }
                        {
									offset >= limit && status !== 88 && <Forward className="mr-10 mt-5 rotate-180deg curP" onClick={goToPrevPage} />
                        }
                        {
                           rfqs && rfqs.length >= 10 && status !== 88 && <Forward className="mr-40 mt-5 curP" onClick={goToNextPage} />
                        }
                        {
									rfqs && (rfqs.length == 0 || rfqs.length < 10) && status !== 88 && <Back className="mr-10 mt-5 rotate-180deg" />
                        }
                     </div>
                  </div>
               </div>
            </div>
            {status !== 88 && 
               this.getHeaders(status, rfqs)
            }
				{status === 88 && this.getServiceCategoryBody()}
            {
               (rfqs || []).map((rfq, index) => {
                  return this.getBody(status, rfq, index);
               })
            }
				{!(rfqs && rfqs.length > 0) && !gettingRfqs && status !== 88 &&
               <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">No RFQ Has Been Added</div>
            }
         </div>
      )
   }
}
